import React from "react";
import DocDetails from "./DocDetails";

const Documentation = () => {
  return (
    <div>
      <div className="sm:mx-2 py-4 mb-4 border-b border-content/40 border-dashed">
        <div className="flex justify-between items-start">
          <div>
            <h1 className="text-xl font-bold text-primary">
              View Documentation
            </h1>
            <p className="text-sm text-muted mt-1">
              Get help and access resources
            </p>
          </div>
        </div>
      </div>
      {/*  */}
      <DocDetails />
    </div>
  );
};

export default Documentation;
